import { IconButton, Spinner } from '@cian/ui-kit';
import { IconActionClose16 } from '@cian/ui-kit-design-tokens/icons';
import { clsx } from 'clsx';
import * as React from 'react';

import * as styles from './ChatPopup.css';

interface IChatPopupProps {
  src: string;
  onClose(): void;
  aboveModal?: boolean;
}

export const ChatPopup: React.FC<IChatPopupProps> = ({ src, onClose, aboveModal }) => {
  const [isLoading, setIsLoading] = React.useState(true);

  const onLoad = () => setIsLoading(false);

  return (
    <div className={clsx(styles['container'], aboveModal && styles['above-modal'])}>
      <span className={styles['close']}>
        <IconButton aria-label="Закрыть" icon={<IconActionClose16 />} onClick={onClose} />
      </span>
      {isLoading && (
        <span className={styles['spinner']} data-testid="spinner">
          <Spinner size={16} />
        </span>
      )}
      <iframe data-testid="ChatModal" className={styles['iframe']} src={src} onLoad={onLoad} onError={onLoad} />
    </div>
  );
};
